import Skeleton from "common/components/ui/Skeleton";
import type { CreatedTemplate } from "common/types";

import TemplatesListItem from "./TemplatesListItem";

export default function TemplatesList({
  isLoading,
  templates,
}: {
  isLoading: boolean;
  templates: CreatedTemplate[];
}) {
  return (
    <div className="flex flex-col overflow-y-auto scrollbar-thin">
      {isLoading
        ? new Array(7).fill({}).map((_, index) => (
            <div
              className="flex items-center gap-x-2 border-b border-b-black-200 p-4"
              // biome-ignore lint/suspicious/noArrayIndexKey: no key available
              key={index}
            >
              <Skeleton className="size-10 rounded-2xl" />
              <div className="flex flex-1 flex-col gap-y-0.5">
                <Skeleton className="h-5 w-32" />
                <div className="flex justify-between">
                  <Skeleton className="h-4 w-10" />
                  <Skeleton className="h-4 w-10" />
                  <Skeleton className="h-4 w-10" />
                </div>
              </div>
            </div>
          ))
        : templates.map((template) => (
            <TemplatesListItem key={template.id} template={template} />
          ))}
    </div>
  );
}
